var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEggDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 70,
    viewBox: "0 0 57 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eggs",
    filter: "url(#filter0_i_710_1111)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 56,
    height: 70,
    rx: 2,
    fill: "#1F272A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter1_i_710_1111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 9C18.1911 9 9.5 26.3801 9.5 40.4681C9.5 54.5561 18.271 60 29 60C39.729 60 48.5 54.5561 48.5 40.4681C48.5 26.3801 39.729 9 29 9Z",
    fill: "#1F272A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 9C18.1911 9 9.5 26.3801 9.5 40.4681C9.5 54.5561 18.271 60 29 60C39.729 60 48.5 54.5561 48.5 40.4681C48.5 26.3801 39.729 9 29 9Z",
    fill: "url(#paint0_linear_710_1111)",
    fillOpacity: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_710_1111",
    x: 0.5,
    y: 0,
    width: 56,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_710_1111"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_710_1111",
    x: 9.5,
    y: 9,
    width: 39,
    height: 55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_710_1111"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_710_1111",
    x1: 32,
    y1: 46,
    x2: 20.5,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggDefault);
export default __webpack_public_path__ + "static/media/eggDefault.df84098c3304cc62e7a3aedd21e9201a.svg";
export { ForwardRef as ReactComponent };